module.exports = __webpack_public_path__ + "ClientApp/images/content/block-rich-resources/Bohdi5-fixed.jpg";